import React from 'react';
import { mapConcessionToIcons } from './utils/mapConcession';
export const EpicValueTitle = ({ concession }) => {
    var _a;
    return React.createElement("div", null, (_a = mapConcessionToIcons[concession]) === null || _a === void 0 ? void 0 : _a.label);
};
